import { Button } from "@/components/ui/button";

interface TopicButtonProps {
  name: string;
  isSelected: boolean;
  onClick: () => void;
}

export default function TopicButton({
  name,
  isSelected,
  onClick
}: TopicButtonProps) {
  return (
    <Button
      variant={isSelected ? "default" : "outline"}
      className="w-full justify-start h-auto py-3"
      onClick={onClick}
      data-testid={`button-topic-${name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      <span className="flex-1 text-left">{name}</span>
    </Button>
  );
}
